<template>
  <el-card>
    <el-button type="primary" @click="getTableData">{{ $t('channel.label.refresh') }}</el-button>
    <el-row style="margin: 10px 0;">
      <el-table
        border
        :data="tableData"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
        stripe>
        <el-table-column type="index" label="#"/>
        <el-table-column prop="configName" align="center" :label="$t('sysConfig.configName')" />
        <el-table-column align="center" :label="$t('sysConfig.configAmount')">
          <template slot-scope="{ row }">
            <el-input size="medium" v-model="row.configValue"/>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('channel.label.action')">
          <template slot-scope="{row}">
            <el-button slot="reference" type="primary" size="mini" @click="handleUpdateValue(row)" >
              {{ $t('sysConfig.update') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </el-card>
</template>

<script>
import { debounce } from 'lodash';
import sysConfig from '../../api/sysConfig';

// oninput ="value=value.replace(/[^0-9.]/g,'')"

export default {
  name: 'systemConfig',
  data() {
    return {
      configValue: '',
      tableData: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    init() {
      this.handleSearch = debounce(this._handleSearch, 300);
    },
    async getTableData() {
      const { data } = await sysConfig.getSysConfigList({ data: {} });
      if (data && data.code === 200) {
        this.tableData = data.data.map((item) => ({ ...item, newValue: '' }));
      }
    },
    async handleUpdateValue(rowData) {
      const { id, configKey, configValue } = rowData;
      const params = {
        id,
        configKey,
        configValue
      };
      const { data } = await sysConfig.configUpdate(params);
      if (data.code === 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg);
      }
      this.getTableData();
    },
    /* --------------------------------- 事件驱动函数 --------------------------------- */
    handleEmpty() {
      this.form = {
        id: "",
        channelName: "",
        createAcct: "",
        createTime: "",
        isOpen: ""
      };
    },
    handleEditor(row) {
      this.$refs.editor.init(row);
    },
    _handleSearch() {
      this.$refs.form.validate(async (valid) => valid && this.getTableData());
    },

    // showTripleChannel(list){
    //   if (list.length > 0) {
    //     return <i>N/A</i>
    //   } else {
    //     return list.filter(sItem=>sItem.status === 1).map(item=>item.tripleChannel).join(', ')
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
i{
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/systemConfig/index.vue